
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2024-06-02-react-three-fiber-1-basic-demo",
      function () {
        return require("private-next-pages/blogs/2024-06-02-react-three-fiber-1-basic-demo/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2024-06-02-react-three-fiber-1-basic-demo"])
      });
    }
  